<template>
  <div></div>
</template>

<script>
import store from '../store/store'
import {ebus} from "../vendor/ebus";
import * as bootstrap from "../vendor/bootstrap";
import axios from "axios";
import {kioskResetTimeoutOnInactivity} from "../vendor/qconstants";
import {clearEvents, doReload} from "../vendor/util";

const stableAxios = axios.create()

export default {
  name: "KioskLifecycle",
  data() {
    return {
      idleTimer: null,
      lastActivity: 0,
      throttleDelay: 1000
    }
  },
  created() {
    ebus.$on('postToWindowskiosk', (params) => {
      if (store.getters.isAndroidKiosk || !store.getters.isKiosk) {
        return;
      }
      console.log('KioskLifecycle emit received postToWindowskiosk');
      this.$nextTick(() => {
        this.postToWindowskiosk(params);
      });
    });
    ebus.$on('resetKiosk', () => {
      this.resetKiosk(false);
    });
    ebus.$on('resetKioskReload', () => {
      this.resetKiosk(true);
    });
  },
  mounted() {
    if (store.getters.isKiosk) {
      this.init();
    }
  },
  beforeDestroy() {
    this.clearIdleTimer();
    const events = ['mousemove', 'keypress', 'click', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.removeEventListener(event, this.boundHandler);
    });
  },
  destroyed() {
    clearEvents([
      'postToWindowskiosk',
      'cb-postToWindowskiosk',
      'resetKiosk',
      'resetKioskReload'
    ]);
  },
  methods: {
    init() {
      this.startIdleTimer();

      // Wir binden die Methode an 'this', damit wir sie später sauber entfernen können
      this.boundHandler = this.throttledReset.bind(this);

      const events = ['mousemove', 'keypress', 'click', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.addEventListener(event, this.boundHandler, {passive: true});
      });
    },

    resetKiosk(shouldReload) {
      if (!store.getters.isKiosk) {
        return;
      }
      store.commit('deleteAllCartItems');
      store.commit('setShowKioskSplashOnHome', true);
      this.$ls.remove('selectedOrderModeByUser');

      this.$router.replace({name: 'Home'});
      if (shouldReload) {
        doReload('resetKiosk');
      }
    },
    throttledReset() {
      const now = Date.now();
      // Nur ausführen, wenn der letzte Reset länger als 'throttleDelay' her ist
      if (now - this.lastActivity < this.throttleDelay) {
        return;
      }
      console.info('lastActivity updated ...');
      this.lastActivity = now;
      this.resetIdleTimer();
    },
    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(this.goToStart, kioskResetTimeoutOnInactivity);
    },
    startIdleTimer() {
      this.idleTimer = setTimeout(this.goToStart, kioskResetTimeoutOnInactivity);
    },
    goToStart() {
      console.info('kioskResetTimeoutOnInactivity now...');
      let rName = this.$route.name;
      if (rName && rName.toLowerCase().indexOf('checkout') !== -1) {
        //ignore
        this.resetIdleTimer();
      } else {
        this.resetIdleTimer();
        this.resetKiosk(false);
      }
      // if (this.$route.path !== '/') {
      //   this.$router.push('/').catch(err => {
      //     // Ignoriere NavigationDuplicated Fehler
      //     if (err.name !== 'NavigationDuplicated') throw err;
      //   });
      // }
    },
    clearIdleTimer() {
      if (this.idleTimer) clearTimeout(this.idleTimer);
    },

    async postToWindowskiosk(params) {
      if (!store.getters.isKiosk || store.getters.isAndroidKiosk) {
        console.log('KioskLifecycle postToWindowskiosk isKiosk=false');
        return;
      }

      const action = params.action;
      console.log('KioskLifecycle going to post postToWindowskiosk for action ' + action);

      params.terminalId = '1';
      let timeout = 3000;
      if (action === 'checkTerminalServiceActive') {
        timeout = 2000;
      } else if (action === 'triggerPosTerminal') {
        timeout = 1000 * (120 + 180);
      }
      if (params.timeout) {
        timeout = params.timeout;
      }

      await this.post(params, (reply) => {
        reply.action = action
        if (reply.ok) {
          console.log('KioskLifecycle postToWindowskiosk was ok for action ' + action);
        } else {
          console.log('KioskLifecycle error: postToWindowskiosk was notok for action ' + action);
        }
        if (params.cb) {
          ebus.$emit(params.cb, reply);
        }
      }, (err) => {
        console.log('KioskLifecycle error in postToWindowskiosk for action ' + action + ': ' + err);
        if (params.cb) {
          ebus.$emit(params.cb, {ok: false, error: err, action: action});
        }
      }, timeout);
    },

    async post(message, callback, error, timeoutOverride) {
      if (!message) {
        return;
      }

      // const baseURL = 'https://qdev.de:8088/';
      const baseURL = 'https://localhost:8088/';
      const endpoint = baseURL + 'v1/kiosk/postHandler';

      message.btaste = bootstrap.getBtaste();

      console.log('KioskLifecycle >>>>>>>>>> POST ', message);

      let timeout = 10000;
      if (timeoutOverride) {
        timeout = timeoutOverride;
      }
      message.timeout = timeout;

      message['Kiosk-Authorization'] = 'pVr0oSIvUGUX9jI8S9ZtmT';

      try {
        try {
          console.log('KioskLifecycle going to post message to ' + endpoint + ' for action: ' + message.action);
          stableAxios
            .post(endpoint, message, {
              headers: {
                'Content-Type': 'application/json',
              }, timeout: timeout
            })
            .then((reply) => {
              // console.log('KioskLifecycle <<< Reply ', reply);
              // console.log('KioskLifecycle <<< Reply :' + JSON.stringify(reply));
              if (reply && reply.data) {
                callback(reply.data);
              } else {
                console.log('KioskLifecycle response not ok');
                error();
              }
            }).catch((err) => {
            // error callback
            console.log('KioskLifecycle Catched error: ', err);
            if (error) {
              error(err);
            }
          });
        } catch (sendError) {
          console.log('KioskLifecycle sendException: ' + sendError);
          error(sendError);
        }
      } catch (outerErr) {
        console.log('KioskLifecycle Unexpected error', outerErr);
        if (error) {
          error(outerErr);
        }
      }
    }
  }// eof methods
}
</script>


